// Runtime configuration, fail closed (CLAUDE.md rule 1): production reads window.__FSA_CONFIG__ written into
// /config.js by the container entrypoint; development reads the Vite env (.env.local, never committed). There
// are no defaults — a missing value shows a configuration error instead of silently talking to another project.

export interface AppConfig {
  supabaseUrl: string;
  supabaseAnonKey: string;
  mapStyleUrl: string;
  /** Public address of the web app; asset labels encode <publicUrl>/a/<company_code>/<asset_code>. */
  publicUrl: string;
}

declare global {
  interface Window {
    __FSA_CONFIG__?: Partial<AppConfig>;
  }
}

export class ConfigMissingError extends Error {
  constructor(readonly missing: string[]) {
    super(`missing configuration: ${missing.join(', ')}`);
    this.name = 'ConfigMissingError';
  }
}

export function loadConfig(
  runtime: Partial<AppConfig> | undefined = typeof window === 'undefined'
    ? undefined
    : window.__FSA_CONFIG__,
  env: Record<string, string | undefined> = import.meta.env,
): AppConfig {
  const config = {
    supabaseUrl: runtime?.supabaseUrl || env.VITE_SUPABASE_URL,
    supabaseAnonKey: runtime?.supabaseAnonKey || env.VITE_SUPABASE_ANON_KEY,
    mapStyleUrl: runtime?.mapStyleUrl || env.VITE_MAP_STYLE_URL,
    publicUrl: (runtime?.publicUrl || env.VITE_PUBLIC_URL)?.replace(/\/+$/, ''),
  };
  const missing = Object.entries(config)
    .filter(([, value]) => !value)
    .map(([key]) => key);
  if (missing.length) throw new ConfigMissingError(missing);
  return config as AppConfig;
}
